import type { Theme } from '@mui/material';
import { Box, Grid2 as Grid } from '@mui/material';
import { appBarHeight } from '@/components/AppBar/AppBar.style';
import { footerHeight } from '@/components/Footer';
import { useGetFeatureFlags } from '@/hooks/useGetFeatureFlags';

const lngAssetValuationStyles = {
  root: {
    height: `calc(100vh - ${appBarHeight} - ${footerHeight})`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: (theme: Theme) => theme.palette.primaryBackground.backgroundColor,
  },
  emptyState: {
    textAlign: 'center',
    color: (theme: Theme) => theme.palette.text.secondary,
  },
};

const LngAssetValuation = () => {
  return (
    <Grid
      container
      direction='column'
      flexWrap='nowrap'
      sx={lngAssetValuationStyles.root}
      data-id='lng-asset-valuation-layout'
    >
      <Box sx={lngAssetValuationStyles.emptyState}>LNG Asset Valuation</Box>
    </Grid>
  );
};

const LngAssetValuationPage = () => {
  const { lngAssetValuation } = useGetFeatureFlags();

  if (!lngAssetValuation) {
    return null;
  }

  return <LngAssetValuation />;
};

export default LngAssetValuationPage;
